import { logger as browserLogger } from '@/logger/logger.browser';

export async function checkEligibility(email: string) {
  try {
    const resp = await fetch('/api/checkEligibility', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });

    if (!resp.ok) {
      browserLogger.warn('checkEligibility returned a non-ok response', {
        status: resp.status,
      });
      return undefined;
    }

    return await resp.json();
  } catch (error) {
    browserLogger.warn('Error calling checkEligibility', {
      error,
    });
  }
}
